import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane } from '@coreui/react'
import { getMetaData } from '../../../../Redux/Actions/metaDataAction'
import CategoryListing from './categoryListing'
import SubCategoryListing from './subCategoryListing'
import { isEmpty } from 'src/views/utils/helper'

const SystemDefined = () => {
  const dispatch = useDispatch()
  const [activePane, setActivePane] = useState(1)
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const { refreshData } = useSelector((state) => state.commonReducer)

  useEffect(() => {
    getCategories()
  }, [refreshData])

  const getCategories = async () => {
    const res = await dispatch(getMetaData('system'))
    if (res?.success && !isEmpty(res?.data)) {
      let { data } = res
      setCategories(data.filter((obj) => obj.type === 'category'))
      setSubCategories(data.filter((obj) => obj.type === 'sub_category'))
    }
  }
  const activeTab = { color: '#1976d2', fontSize: '1.1rem' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem' }
  return (
    <>
      <CRow className="mt-3">
        <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              style={activePane === 1 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              Category
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={activePane === 2 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              Sub-Category
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane role="tabpanel" visible={activePane === 1}>
            <CategoryListing categories={categories} subCategories={subCategories} />
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 2}>
            <SubCategoryListing
              subCategories={subCategories}
              categories={categories.filter((cat) => cat.status)}
            />
          </CTabPane>
        </CTabContent>
      </CRow>
    </>
  )
}

export default SystemDefined
